import { atom } from 'jotai';

export const notificationDrawerExpandedAtom = atom(false);
